import A from 'actions/provider/providerActions';
import { RSAA } from 'redux-api-middleware';

export const 
toggleProviderCaptchaView = (forceResult) => ({ type: A.PROVIDER_TOGGLE_CAPTCHA_VIEW, payload: forceResult }),
toggleProviderAllowSubmit = (forceResult) => ({ type: A.PROVIDER_TOGGLE_ALLOW_SUBMIT, payload: forceResult }),
toggleInvalidProviderEmailError = () => ({ type: A.TOGGLE_INVALID_PROVIDER_EMAIL_ERROR }),
toggleProviderFAACertError = () => ({ type: A.TOGGLE_PROVIDER_FAA_CERT_ERROR }),
loadAllSchools = () => ({ [RSAA]: {
        endpoint: '/organization',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        types: [
            A.LOAD_ALL_SCHOOLS_REQUEST,
            A.LOAD_ALL_SCHOOLS_SUCCESS,
            A.LOAD_ALL_SCHOOLS_FAILURE
        ]
    }
});
